import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../Shared/Button";
import { getCoreplusPreload, getFirestorePreload } from "../../services/db4";
import { setPreload } from "../appSlice";

const SyncCoreplus = () => {
  const dispatch = useDispatch();
  const [isSyncingStaticData, setIsSyncingStaticData] = useState(false);
  const [syncError, setSyncError] = useState("");
  const [syncedAt, setSyncedAt] = useState(null);

  const handleSyncStaticData = async () => {
    setIsSyncingStaticData(true);
    setSyncError("");
    setSyncedAt(null);
    try {
      await getCoreplusPreload();
      const preload = await getFirestorePreload();
      dispatch(setPreload(preload));
      setSyncedAt(new Date());
    } catch (error) {
      // Failing silently is what made a timed-out sync look like a successful one.
      setSyncError(error?.message || "Sync failed. Please try again.");
    } finally {
      setIsSyncingStaticData(false);
    }
  };

  const dataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";
  return (
    <div className="columns">
      <div className="column is-half">
        <p className="menu-label">{dataFromPMS ? "synchronizing pms data" : "synchronizing coreplus with firebase"}</p>
        <Button text="SYNC" onClick={handleSyncStaticData} isLoading={isSyncingStaticData} />
        {syncError ? <p className="help is-danger">{syncError}</p> : null}
        {syncedAt ? <p className="help is-success">Synced at {syncedAt.toLocaleTimeString()}</p> : null}
      </div>
    </div>
  );
};

export default SyncCoreplus;
